export type FormFieldTypes = {
  label: string;
  errorLabel: string;
};

interface WeekShortLabel {
  weekShortLabel: string;
}

export type WeekDaysShort = WeekShortLabel[];

interface WeekLongLabel {
  weekLongLabel: string;
}
export type WeekDaysLong = WeekLongLabel[];

interface MonthLabel {
  monthLabel: string;
}
export type Months = MonthLabel[];

export type TopicValueType = 'NA' | 'FBR' | 'HI' | 'CCAPHS' | 'CCAF' | 'GMF' | 'GEMT' | 'MS' | 'MSTA' | 'MRMAP';

export type TopicListType = {
  label: string;
  value: TopicValueType;
};

export type ContactUSMainComponentUIStateType = {
  isApiError: boolean;
  showHotelBookInformation: boolean;
  showContactInformationAndBtnContainer: boolean;
  showLegalTextWithLink: boolean;
  isApiCallStarted: boolean;
  isSubmitBtnDisabled: boolean;
};

export const initialContactUSMainComponentUIState: ContactUSMainComponentUIStateType = {
  isApiError: false,
  showHotelBookInformation: false,
  showContactInformationAndBtnContainer: false,
  showLegalTextWithLink: false,
  isApiCallStarted: false,
  isSubmitBtnDisabled: false,
};

export type ContactUsMainComponentProps = {
  pageTitle: string;
  fieldRequiredText: string;
  chooseATopicLabel: string;
  submitButtonText: string;
  clearButtonText: string;
  topicLabel: string;
  dropDownPlaceholder: string;
  apiErrorMessage: string;
  confirmationPageUrl: string;
  components: {
    contactInformation: {
      componentTitle: string;
      componentAuthTitle: string;
      firstName: FormFieldTypes;
      lastName: FormFieldTypes;
      email: FormFieldTypes;
      memberNumber: FormFieldTypes;
      country: FormFieldTypes;
      address1: FormFieldTypes;
      address2: FormFieldTypes;
      city: FormFieldTypes;
      state: FormFieldTypes;
      zipCode: FormFieldTypes;
    };
    hotelBookInformation: {
      typeAndSearchWithLink: {
        searchFieldLabel: FormFieldTypes;
        searchResultFirstFieldValue: string;
        searchResultLastFieldValue: string;
        isLinkRequired?: boolean;
        linkLabel?: string;
      };
      checkInDate: FormFieldTypes;
      checkOutDate: FormFieldTypes;
      confirmationNumber: FormFieldTypes;
      comments: FormFieldTypes;
      complimentRadioButtonLabel: string;
      concernRadioButtonLabel: string;
      subTopicLabel: string;
      hotelServiceDescriptionText: string;
      hotelCreditCardReservationsText: string;
      commentsStillHaveAQuestionText: string;
      marriottBonvoyAccountCombineMultipleAccountsText: string;
      marriottBonvoyAccountEarningText: string;
      complimentConcernStaffFeedbackSubTopicCommentsPlaceholder: string;
      complimentConcernFoodAndBeverageSubTopicCommentsPlaceholder: string;
      optionFieldText: string;
      weekDaysShort: string[];
      weekDaysLong: string[];
      months: string[];
    };
    legalTextWithLink: {
      descriptionText: string;
    };
  };
};

export type ContactUSFormAEMModelType = {
  pageTitle: string;
  fieldRequiredText: string;
  chooseATopicLabel: string;
  submitButtonText: string;
  clearButtonText: string;
  topicLabel: string;
  optionalLabel: string;
  dropDownPlaceholder: string;
  apiErrorMessage: string;
  confirmationPageUrl: string;
  contactInformation: {
    componentTitle: string;
    componentAuthTitle: string;
    firstName: FormFieldTypes;
    lastName: FormFieldTypes;
    email: FormFieldTypes;
    memberNumber: FormFieldTypes;
    country: FormFieldTypes;
    address1: FormFieldTypes;
    address2: FormFieldTypes;
    city: FormFieldTypes;
    state: FormFieldTypes;
    zipCode: FormFieldTypes;
  };
  hotelBookInformation: {
    typeAndSearchWithLink: {
      searchFieldLabel: FormFieldTypes;
      searchResultFirstFieldValue: string;
      searchResultLastFieldValue: string;
      isLinkRequired?: boolean;
      linkLabel?: string;
    };
    checkInDate: FormFieldTypes;
    checkOutDate: FormFieldTypes;
    confirmationNumber: FormFieldTypes;
    comments: FormFieldTypes;
    complimentRadioButtonLabel: string;
    concernRadioButtonLabel: string;
    subTopicLabel: string;
    hotelServiceDescriptionText: string;
    hotelCreditCardReservationsText: string;
    commentsStillHaveAQuestionText: string;
    marriottBonvoyAccountCombineMultipleAccountsText: string;
    marriottBonvoyAccountEarningText: string;
    complimentConcernStaffFeedbackSubTopicCommentsPlaceholder: string;
    complimentConcernFoodAndBeverageSubTopicCommentsPlaceholder: string;
    optionFieldText: string;
    weekDaysShort: WeekDaysShort;
    weekDaysLong: WeekDaysLong;
    months: Months;
  };
  legalTextWithLink: {
    descriptionText: string;
  };
};

export type PhoenixLegalContactUsTopicsAndSubTopicsType = {
  contentListsByType: {
    key: string;
    value: string;
    description: string;
  }[];
};
